<template>
  <div class="component">
    <b-breadcrumb :items="items"></b-breadcrumb>
    <hr />
    <div class="container-fluid container-padding">
      <div class="row">
        <div class="col-lg-6 col-6">
          <div class="companyName h-100 d-flex">
            {{ company.corporate_name }}
          </div>
        </div>
        <div class="col-lg-4 col-6">
            <span class="textGray">Selecione uma máquina</span>
            <multiselect
              v-model="selectedMachineObject"
              :options="machines"
              track-by="id"
              label="name"
              placeholder="Pesquisar Máquinas"
              :searchable="true"
              :allow-empty="true"
              :clear-on-select="false"
              :close-on-select="true"
            >
            </multiselect>
        </div>
        <div class="col-lg-2 col-12">
          <div class="companyLogo d-flex">
            <img src="@/assets/unisafety-logo.png" alt />
          </div>
        </div>
      </div>
      <div class="row" style="margin-top: 18px">
        <div class="col col-padding">
          <router-link
            style="text-decoration: none"
            :to="{
              name: 'Machines_List',
              params: {
                company_id: localCompanyId,
                machine_id: isAllMachinesSelected ? '' : selectedMachine,
                corporate_name: company.corporate_name,
              },
            }"
          >
            <div class="documentTypes w-100 d-flex">
              <div>
                <img class="imgIcon" src="@/assets/icons/machine-icon.png" />
              </div>
              <div class="documentType">
                Máquinas
                <br />
                <span class="number">
                  <b>{{ document_quantities.machines }}</b
                  >&nbsp; </span
                >&nbsp;TOTAL
              </div>
            </div>
          </router-link>
        </div>
        <div class="col col-padding">
          <router-link
            style="text-decoration: none"
            :to="{
              name: 'ListDocuments',
              params: {
                machine_id: isAllMachinesSelected ? '' : selectedMachine,
                company_id: localCompanyId,
                doctype: 'Inventory',
                docTypeText: 'Inventários',
              },
            }"
          >
            <div class="documentTypes w-100 d-flex">
              <div class="icon">
                <font-awesome-icon icon="list" />
              </div>
              <div class="documentType">
                Inventário
                <br />
                <span class="number">
                  <b>{{ document_quantities.inventories }}</b
                  >&nbsp; </span
                >&nbsp;TOTAL
              </div>
            </div>
          </router-link>
        </div>

        <div class="col col-padding">
          <router-link
            style="text-decoration: none"
            :to="{
              name: 'ListDocuments',
              params: {
                machine_id: selectedMachine,
                company_id: localCompanyId,
                doctype: 'APR',
                docTypeText: `APR's`,
              },
            }"
          >
            <div class="documentTypes w-100 d-flex">
              <div class="icon">
                <font-awesome-icon icon="hand-paper" />
              </div>
              <div class="documentType">
                APR
                <br />
                <span class="number">
                  <b>{{ document_quantities.hazard_analysis }}</b
                  >&nbsp; </span
                >&nbsp;TOTAL
              </div>
            </div>
          </router-link>
        </div>
        <div class="col col-padding">
          <router-link
            style="text-decoration: none"
            :to="{
              name: 'ListDocuments',
              params: {
                machine_id: selectedMachine,
                company_id: localCompanyId,
                doctype: 'ActionPlan',
                docTypeText: `Planos de Ação`,
              },
            }"
          >
            <div class="documentTypes w-100 d-flex">
              <div class="icon">
                <font-awesome-icon icon="cog" />
              </div>
              <div class="documentType">
                Plano de Ação
                <br />
                <span class="number">
                  <b>{{ document_quantities.action_plans }}</b
                  >&nbsp; </span
                >&nbsp;TOTAL
              </div>
            </div>
          </router-link>
        </div>
        <div class="col col-padding">
          <router-link
            style="text-decoration: none"
            :to="{
              name: 'ListDocuments',
              params: {
                machine_id: selectedMachine,
                company_id: localCompanyId,
                doctype: 'Diagnoses',
                docTypeText: 'Diagnósticos',
              },
            }"
            class="link"
          >
            <div class="documentTypes w-100 d-flex">
              <div class="icon">
                <font-awesome-icon icon="eye-slash" />
              </div>
              <div class="documentType">
                Diagnóstico
                <br />
                <span class="number">
                  <b>{{ document_quantities.nr_references }}</b
                  >&nbsp; </span
                >&nbsp;TOTAL
              </div>
            </div>
          </router-link>
        </div>
        <div class="col col-padding">
          <router-link
            style="text-decoration: none"
            :to="{
              name: 'ListDocuments',
              params: {
                machine_id: selectedMachine,
                company_id: localCompanyId,
                doctype: 'DVS',
                docTypeText: `DVS's`,
              },
            }"
          >
            <div class="documentTypes w-100 d-flex">
              <div class="icon">
                <font-awesome-icon icon="shield-alt" />
              </div>
              <div class="documentType">
                DVS
                <br />
                <span class="number">
                  <b>{{ document_quantities.security_validations }}</b
                  >&nbsp; </span
                >&nbsp;TOTAL
              </div>
            </div>
          </router-link>
        </div>
      </div>
      <div v-if="selectedMachine != '0' && selectedMachine != 0">
        <div class="row listFolders">
          <div
            v-for="folder in directories"
            v-bind:key="folder.id"
            class="col-lg-6 col-12"
          >
            <router-link
              :to="{
                name: 'Folder',
                params: {
                  company_id: company_id,
                  folder_id: folder.id,
                  machine_id: selectedMachine,
                  machine_name: selectedMachineObject.name
                },
              }"
              style="text-decoration: none"
            >
              <div class="folder d-flex">
                <span>{{ folder.name }}</span>
                <!-- <small class="textGray">3 máquinas</small> -->
                <font-awesome-icon icon="angle-right" />
              </div>
            </router-link>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div
              class="w-100 d-flex justify-content-end"
              style="margin-top: 20px"
            >
              <button
                class="btn btn-primary"
                v-on:click="openModal('new-directory-modal')"
              >
                <span>Nova pasta <font-awesome-icon icon="plus" /> </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 mt-2" v-if="selectedMachine == '0' || selectedMachine == 0">
        <div class="card-info border-solid text-center big">
          <div class="card-info-header">
            <h5>Documentos</h5>
          </div>
          <div class="card-content">
            <div v-if="access_denied" class="text-center py-3">
              <p class="text-muted mb-1">
                Você não tem acesso a essa empresa.
              </p>
              <a href="#/admin/Documents/Index">Retorne à sessão Documentos</a>
            </div>
            <template v-else>
              <pie-chart
                v-if="pie_chart_data_loaded"
                :labels="pie.labels"
                :colors="pie.colors"
                :data="[
                  document_quantities.inventories,
                  document_quantities.hazard_analysis,
                  document_quantities.action_plans,
                  document_quantities.nr_references,
                  document_quantities.security_validations,
                ]"
              ></pie-chart>
              <p>Total de Documentos: {{ document_quantities.total }}</p>
            </template>
          </div>
        </div>
      </div>

      <b-modal ref="new-directory-modal" title="Nova pasta" @ok="handleOk">
        <input
          type="text"
          v-model="newFolderName"
          placeholder="Nome"
          id
          class="form-control"
        />

        <template v-slot:modal-cancel>Cancelar</template>
        <template v-slot:modal-ok>Criar</template>
        <br />
        <b-alert v-show="alert_field" :variant="alert_field_type" show>{{
          alert_field_msg
        }}</b-alert>
      </b-modal>
    </div>
  </div>
</template>
<script>
import { postDocumentsQuantity } from "@/api/admin/company";
import axios from "@/api/axios";
import PieChart from "@/components/charts/PieChart.vue";
import Vue from "vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
Vue.use(Loading);

export default {
  name: "CompanyDocuments",
  components: {
    PieChart,
    Multiselect,
  },
  props: {
    company_id: String,
  },
  data() {
    return {
      localCompanyId: this.company_id || localStorage.getItem('company_id'),
      tempComp: "",
      company: {},
      document_quantities: [],
      directories: [],
      newFolderName: "",
      selectedMachine: "0",
      selectedMachineObject: null,
      currentDocuments: [],
      machines: [],
      items: [
        {
          text: "Documentos",
          href: "#/admin/Documents/Index",
        },
        {
          text: "",
          active: true,
        },
      ],
      alert_field: false,
      pie_chart_data_loaded: false,
      access_denied: false,
      pie: {
        labels: ["Inventário", "APR", "Plano de Ação", "Diagnóstico", "DVS"],
        colors: ["#264653", "#2a9d8f", "#e9c46a", "#f4a261", "#e76f51"],
      },
      alert_field_type: "success",
      alert_field_msg: "Item salvo com sucesso",
      modalEventControl: true,
    };
  },
  async mounted() {
    if (this.localCompanyId) {
      this.getCompany(this.localCompanyId);
      const loader = this.$loading.show();
      const resp = await this.getMachinesByCompanyId();

      if (this.$route.query?.machine_id) {
        const mach = resp.find(m => m.id === this.$route.query?.machine_id);
        this.selectedMachine = mach.id,
        this.selectedMachineObject = {
          id: mach.id,
          name: mach.name,
        }
      }
      await this.getCompanyDocumentQuantities();
      await this.getRootDirectories();
      loader.hide();
    }
  },
  watch: {
    selectedMachine: {
      handler() {
        this.updateSelectedMachineObject();
      },
      immediate: true
    },
    company: {
      handler() {
        this.updateSelectedMachineObject();
      }
    },
    selectedMachineObject: {
      handler(newVal) {
        if (newVal) {
          this.selectedMachine = newVal.id;
          this.filter();
        } else {
          this.selectedMachine = "0";
          this.filter();
        }
      }
    },
    company_id(newVal) {
      this.localCompanyId = newVal;
      if (newVal) {
        this.getCompany(newVal);
      }
    },

  },
  computed: {
    isAllMachinesSelected() {
      return this.selectedMachine === "0" || this.selectedMachine === 0;
    },
  },
  methods: {
    getCompany: function (company_id) {
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/admin/companies/${company_id}`)
        .then((response) => {
          this.items[1].text = response.data.data.corporate_name;
        });
    },
    handleOk: function (modalEvent) {
      if (this.newFolderName != "") {
        this.addFolder();
      } else {
        modalEvent.preventDefault();
        this.alert_field_type = "warning";
        this.alert_field_msg = "Por favor, escolha um nome para esta pasta";
        this.alert_field = true;
        const vm = this;
        setTimeout(() => {
          vm.alert_field = false;
        }, 3000);
      }
    },

    getMachinesByCompanyId: async function () {
      const response = await axios.get(
        `${process.env.VUE_APP_API_HOST}/api/admin/machines?company_id=${this.localCompanyId}`,
        {
          params: {
            reduced: true,
            not_paginated: true,
            not_gallery: true,
          },
        }
      );
      this.machines = [
        {id: 0, name: 'Todas as Máquinas'}, 
        ...response.data.data
      ];
      return[
        {id: 0, name: 'Todas as Máquinas'}, 
        ...response.data.data
      ];
    },

    getCompanyDocumentQuantities: async function () {
      this.pie_chart_data_loaded = false;
      try {
        const response = await postDocumentsQuantity({
          companyId: this.localCompanyId,
          machineId: this.selectedMachine,
        });
        this.document_quantities = response.data;
      } catch (error) {
        console.error('Erro ao carregar quantidades de documentos:', error);
        if (error?.response?.status === 403) {
          this.access_denied = true;
        }
      } finally {
        this.pie_chart_data_loaded = true;
      }
    },
    getRootDirectories: async function () {
      if (this.selectedMachine == "0" || this.selectedMachine == 0) {
        axios
          .get(
            `${process.env.VUE_APP_API_HOST}/api/admin/directories?filter[where_is_root]=1&filter[company_id]=${this.localCompanyId}&filter[without_document_directories]='true'`
          )
          .then((response) => {
            this.directories = response.data.data;
          });
      } else {
        axios
          .get(
            `${process.env.VUE_APP_API_HOST}/api/admin/directories?filter[where_is_root_or_machine]=${this.selectedMachine}&filter[company_id]=${this.localCompanyId}&filter[without_document_directories]='true'`
          )
          .then((response) => {
            this.directories = response.data.data;
          });
      }
    },
    openModal: function (modal) {
      this.$refs[modal].show();
    },
    resetModal() {
      this.newFolderName = "";
    },
    filter: async function () {
      if (this.selectedMachine !== null && this.selectedMachine !== undefined) {
        this.selectedMachine = this.selectedMachine.toString();
      }
      await this.getCompanyDocumentQuantities();
      await this.getRootDirectories();
    },
    updateSelectedMachineObject: function() {
      if (this.selectedMachine === "0" || this.selectedMachine === 0) {
        this.selectedMachineObject = { id: "0", name: "Todas as Máquinas" };
      } else if (this.company && this.company.machines) {
        const machine = this.company.machines.find(m => m.id.toString() === this.selectedMachine.toString());
        if (machine) {
          this.selectedMachineObject = { id: machine.id.toString(), name: machine.name };
        }
      }
    },
    addFolder: function () {
      const loader = this.$loading.show();

      axios
        .post(`${process.env.VUE_APP_API_HOST}/api/admin/directories/`, {
          name: this.newFolderName,
          company_id: this.localCompanyId,
          machine_id: this.selectedMachine,
        })
        .then(() => {
          this.getRootDirectories();
          this.resetModal();
          loader.hide();
        })
        .catch(() => {
          this.$bvToast.toast(
            `Desculpe, tivemos algum problema. Por favor tente novamente!`,
            {
              title: `Ocorreu um erro`,
              toaster: "b-toaster-top-center",
              solid: true,
              variant: "danger",
            }
          );
          loader.hide();
        });
    },
  },
};
</script>
<style lang="scss">
@import "../../../styles/General.scss";

.companyName {
  white-space: nowrap;
  align-items: center;
  .textDivisor {
    align-items: center;
    height: 28px;
    border-left: 0.5px solid gray;
    margin-left: 10px;
    padding-left: 10px;
  }
}
.companyLogo {
  justify-content: flex-end;
  align-items: center;
  img {
    height: 5vh;
    width: auto;
  }
}
.link {
  text-decoration: none !important;
}
.documentTypes {
  justify-content: center;
  align-items: center;
  border: 1px solid #dfdcdc;
  border-radius: 5px;
  height: 20vh;
  color: black;
  // color: #858484;
  .icon {
    font-size: 46px;
  }
  .imgIcon {
    height: 50px;
    width: 50px;
  }
  .documentType {
    text-decoration: none;
    text-align: center;
    padding-left: 10px;
    font-size: 18px;
    .number {
      font-size: 24px;
    }
  }

  .documentType:hover {
    text-decoration: none;
  }
}
.documentTypes:hover {
  color: black;
}

.listFolders {
  margin-top: 25px;
  .folder {
    border: 0.8px solid #dfdcdc;
    border-left: 20px solid #dfdcdc;
    margin-top: 8px;
    border-radius: 5px;
    position: relative;
    padding: 12px 20px 12px 20px;
    a {
      color: black;
      text-decoration: none;
    }
    align-items: center;
    svg {
      position: absolute;
      right: 20px;
    }
    small {
      position: absolute;
      right: 45px;
    }
  }
  .folder:hover {
    cursor: pointer;
  }
}

// Estilos básicos para o multiselect
:deep(.multiselect) {
  min-height: 40px;
}
</style>
